<template>
  <div class="activity-warp">
    <div class="activity-head">
      <img class="backicon" src="../../assets/imgs/close.png" @click="onBack">
      <div class="activity-title">{{i18nProduct.title}}</div>
    </div>
    <div class="device-select" style="display: flex">
      <label>{{mifisn}}</label>
      <div style="text-align: right;width: 100%;" >
        <label style="background: #BDBDBD;border-radius: 22px;padding: 5px 10px;color: white;font-size: 10pt;">{{cardOneRealStatus}}</label>
      </div>
    </div>
    <van-tabs v-model="active" animated title-active-color="#1EBE86" color="#1EBE86" @click="tabClick" style="font-family: MyFont6">
      <van-tab v-for="(item, i) in tagDictItems"  :key="i" :title="item.dictName" >
      </van-tab>
    </van-tabs>
    <div style="padding: 0px;">
      <section class="content">
        <div class="item" v-for="(item,index) in productList" :key="index" @click="pkgItemClick(item)">
          <div style="display: flex">
            <div style="width: 70%;text-align: left;height: 30px;margin-top: -2px">
              <label style="background: #1EBE86;padding: 8px;color: white;border-radius: 11px 0px 18px 0px;font-family: MyFont6">{{pkgLab}}</label>
            </div>
            <div style="width: 30%;text-align: right;margin-top: -5px" v-if="item.active === 1">
              <van-image :src="require('assets/imgs/mifi09.png')" width="40px" height="30px"></van-image>
            </div>
          </div>
          <div style="line-height: 60px;font-size: 10pt;text-align: center; ">
            <label style="font-family: MyFont6">{{item.productName}}</label>
          </div>
          <div style="line-height: 30px;border-radius: 0 0 .2rem .2rem;background:white;">
            <div style="margin-left: 2px;color: #FF1919;display: flex;font-family: MyFont7">
              <div style="width: 40%">{{item.purchaseTip}}</div>
              <div style="width: 60%;text-align: right;padding-right: 5px;">
                <label style="font-size: 8pt">￥</label>
                <label style="font-size: 15pt">{{parseFloat(item.salePrice).toFixed(2)}}</label>
                <label style="font-size: 7pt">元</label>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
    <div style="bottom: 30px;position: absolute;width: 100%;text-align: center">
      <van-button @click="buyClick" :disabled="pkgItem.productId? false:true"
                  style="color: white;background: #1EBE86;width: 70%;border-radius: 50px;font-family: MyFont7">立即购买</van-button>
      <div style="display: inline-flex;width: 70%;margin-top: 20px;">
        <div style="width: 50%;text-align: left;display: flex">
          <van-image class="backgroud-img" :src="require('assets/imgs/mifi07.png')" width="30px" height="30px"></van-image>
          <div style="color: #1EBE86;margin: 5px 0 0 5px">关注公众号</div>
        </div>
        <div style="width: 50%;">
          <div style="display: flex;justify-content: right">
            <van-image :src="require('assets/imgs/mifi10.png')" width="22px" height="22px" style="margin-top: 3px"></van-image>
            <div style="color: #1EBE86;margin: 5px 0 0 5px" @click="backHome()">返回首页</div>
          </div>
        </div>
      </div>
    </div>
    <van-action-sheet v-model="buyShow" style="background: #f2f2f2">
      <div>
        <div style="display: flex;margin: 0 20px 0 20px;padding: 10px; background: white;border-radius: 15px">
          <div style="width: 30%">
            <van-image :src="appUrl+pkgItem.selectImg" width="88px" height="88px"></van-image>
          </div>
          <div style="margin-left: 10px;width: 70%">
            <div style="font-size: 13pt;font-weight: bold">{{pkgItem.productName}}</div>
            <div style="padding: 10px 0 15px 0;color:#1EBE86;font-size: 9pt">AI智能加速套餐</div>
            <div style="display: flex">
              <div style="color: #FF1919;width: 40%">
                <label style="font-size: 8pt">￥</label>
                <label style="font-size: 14pt">{{parseFloat(pkgItem.salePrice).toFixed(2)}}</label>
              </div>
              <div style="margin: -5px 0 0 25px;;width: 60%;text-align: right;">
                <van-stepper v-model="productCount" step="1" />
              </div>
            </div>
          </div>
        </div>
        <div style="margin: 10px 20px 0 20px;padding: 10px; background: white;border-radius: 15px">
          <div style="display: flex;width: 100%">
            <div style="width: 50%">
              <label>套餐有效期：</label>
            </div>
            <div style="width: 50%;text-align: right">
              <label>{{pkgItem.suiteExpire}}日</label>
            </div>
          </div>
          <div style="display: flex;width: 100%;padding: 10px 0 10px 0">
            <div style="width: 50%">
              <label>商品金额：</label>
            </div>
            <div style="width: 50%;text-align: right">
              <label>￥{{parseFloat(pkgItem.salePrice).toFixed(2)}}元</label>
            </div>
          </div>
          <div style="display: flex;width: 100%;padding-bottom: 15px;">
            <div style="width: 50%">
              <label>折扣金额：</label>
            </div>
            <div style="width: 50%;text-align: right;color:#FF1919; ">
              <label>{{paymentType == 0 ? 0 :parseFloat(pkgItem.salePrice*productCount - pkgItem.balancePrice*productCount ).toFixed(2)}}元</label>
            </div>
          </div>
          <div style="padding: 15px 0;border-top: 1px solid #e8e6e6">
            <van-radio-group v-model="paymentType" checked-color="#1EBE86">
              <div style="display: flex">
                <div style="width: 50%;display: flex">
                  <div style="padding-right: 10px">
                    <van-image :src="require('assets/imgs/mifi12.png')" width="20px" height="20px"></van-image>
                  </div>
                  <div >微信支付</div>
                </div>
                <div style="width: 50%;">
                  <van-radio name="0" style="justify-content: right"></van-radio>
                </div>
              </div>
              <div style="display: flex;padding: 15px 0 0px 0">
                <div style="width: 50%;display: flex">
                  <div style="padding-right: 10px">
                    <van-image :src="require('assets/imgs/mifi13.png')" width="20px" height="20px"></van-image>
                  </div>
                  <div>余额支付</div>
                </div>
                <div style="width: 50%">
                  <van-radio name="1" style="justify-content: right"></van-radio>
                </div>
              </div>
            </van-radio-group>
          </div>
        </div>
        <div style="margin: 10px 20px 20px 20px;padding: 10px; display: flex">
          <div style="color: #FF1919;font-size: 13pt;width: 60%;margin-top: 10px">
            <label style="font-size: 8pt">￥</label>
            <label>{{paymentType == 0 ? parseFloat(pkgItem.salePrice*productCount).toFixed(2) : parseFloat(pkgItem.balancePrice*productCount).toFixed(2)}}</label>
            <label style="font-size: 8pt">元</label>
          </div>
          <div style="width: 40%;text-align: right">
            <van-button type="info" style="border-radius: 18px;width: 80px;font-family: MyFont7" @click="toPay">去支付</van-button>
          </div>
        </div>
      </div>
    </van-action-sheet>
  </div>
</template>

<script>
import { baseURL } from '../../utils/http'
import { MIFI_DEVICE_INFO, MIFI_DICT_CODE, MIFI_PRODUCT_LIST, MIFI_PRODUCT_PAY } from '@/apis/cabinet'
import { mapState } from "vuex";
import item from "../../components/order/item.vue";
export default {
  components: {
  },
  computed: {
    item() {
      return item
    },
    ...mapState(['mifisn']),
    i18nProduct () {
      return this.$t('product')
    }
  },
  watch: {

  },
  data () {
    return {
      tagDictItems: [],
      productList: [],
      active: 0,
      buyShow: false,
      productCount: 1,
      paymentType: '0',
      pkgLab: '',
      pkgItem: {},
      cardOneRealStatus: '未开机',
      appUrl: `${process.env.VUE_APP_Domain}`
    }
  },
  methods: {
    tagDictList() {
      this.$post(
        MIFI_DICT_CODE, {
          devId: this.mifisn
        }, (resp) => {
          this.$loading(false)
          this.tagDictItems = resp.data;
          if (this.tagDictItems.length > 0) {
            this.pkgLab = this.tagDictItems[0].dictName
            this.productListByPkgTab(this.tagDictItems[0].id)
          }
        },
        (error) => {
          this.$loading(false)
          this.$toast(error)
        }
      )
    },
    productListByPkgTab(pkgTabId) {
      this.$post(
        MIFI_PRODUCT_LIST, {
          pkgTabId: pkgTabId
        }, (resp) => {
          this.$loading(false)
          this.productList = resp.data;
          for (var i = 0; i < this.productList.length; i++) {
            this.productList[i].active = 0
          }
        },
        (error) => {
          this.$loading(false)
          this.$toast(error)
        }
      )
    },
    tabClick() {
      var item = this.tagDictItems[this.active]
      this.pkgLab = item.dictName
      this.productList = []
      this.productListByPkgTab(item.id)
      this.pkgItem = {}
    },
    pkgItemClick(item) {
      var p = this.productList;
      for (var i = 0; i < p.length; i++) {
        p[i].active = 0
        if (item.productId === p[i].productId) {
          p[i].active = 1
        }
      }
      this.productList = []
      this.productList = p
      this.pkgItem = item
    },
    buyClick() {
      this.buyShow = true
    },
    toPay() {
      var $this = this
      this.$loading(true)
      this.$post(
        MIFI_PRODUCT_PAY, {
          productId: this.pkgItem.productId,
          buyCount: this.productCount,
          paymentType: this.paymentType,
          devId: this.mifisn
        }, (resp) => {
          /* eslint-disable */
          this.$loading(false)
          if (this.paymentType == 0) {
            WeixinJSBridge.invoke('getBrandWCPayRequest', {
                "appId": resp.data.appId,
                "timeStamp": resp.data.timeStamp,
                "nonceStr": resp.data.nonceStr,
                "package": resp.data.packageValue,
                "signType": 'MD5',
                "paySign": resp.data.paySign
              },
              function (res) {
                this.$loading(false)
                if (res.err_msg === "get_brand_wcpay_request:ok") {
                  $this.$toast("充值成功")
            //      $this.$router.push('/order')
                } else if (res.err_msg === "get_brand_wcpay_request:fail") {
                  $this.$toast("失败")
                }
              });
          } else if(this.paymentType == 1) {
            $this.buyShow = false
            $this.$toast("充值成功")
            $this.$router.push('/order')
          }
          /* eslint-disable */
        },
        (error) => {
          this.$loading(false)
          this.$toast(error)
        }
      )
    },
    deviceInfoById(devId) {
      this.$post(
        MIFI_DEVICE_INFO, {
          devId: devId
        }, (resp) => {
          if (resp.data) {
            if (resp.data.data.online === 0) {
              this.cardOneRealStatus = '离线'
            } else if (resp.data.data.online === 1) {
              this.cardOneRealStatus = '在线'
            } else if (resp.data.data.online === 3) {
              this.cardOneRealStatus = '已拿卡'
            } else if (resp.data.data.online === 4) {
              this.cardOneRealStatus = '拿卡失败'
            } else if (resp.data.data.online === 5) {
              this.cardOneRealStatus = '正在拨号'
            } else if (resp.data.data.online === 6) {
              this.cardOneRealStatus = '下线'
            } else if (resp.data.data.online === 6) {
              this.cardOneRealStatus = '本地卡在线'
            }
          }
        },
        (error) => {
          this.$loading(false)
          this.$toast(error)
        }
      )
    },
    onBack () {
      this.$router.go(-1)
    },
    backHome() {
      this.$router.push('/')
    }
  },
  created () {
    this.tagDictList()
    this.deviceInfoById(this.mifisn)
  }
}
</script>

<style lang="less" scoped>
.activity-warp {
  height: 100vh;
  // background: linear-gradient(#00AB46, #1A2229);
  background: #F4F4F4;
  .activity-head {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 20px;

    .backicon {
      width: 50px;
    }
    .activity-title {
      text-align: center;
      width: 100%;
      font-family: Montserrat, Montserrat;
      font-weight: bold;
      font-size: 36px;
      color: #1A2229;
    }
  }
}
.content {
  width: 100%;
  display: flex;
  flex-wrap: wrap;
}
.item {
  /*  1. 其中 10 为间隙的中和  */
  width: 47%;
  height: 233px;
  margin: 10px;
  background: rgba(30,190,134,0.1);
  border-radius: .2rem;
  padding-top: 12px;
}
.device-select{
  text-align: left;
  border-left: 5px solid #1EBE86;
  margin-left: 20px;
  margin: 20px;
  label{
    font-weight: bold;
    font-size: 32px;
    color: #333333;
    margin-left: 15px;
  }
}
</style>
